<div id="top-purchases-card">
  <div class="top-purchases-card-content">
    <ng-container *ngIf="product$ | async as product">
      <ng-container
        *ngIf="
          product?.summary?.productAssets?.productImages?.C1CC?.renditions
            ?.Thumbnail;
          else noImage
        "
      >
        <img
          [src]="
            product.summary.productAssets.productImages.C1CC.renditions
              .Thumbnail
          "
          alt="Top Purchases"
          class="top-purchases-card-content-image"
        />
      </ng-container>
      <ng-template #noImage>
        <div class="top-purchases-card-content-no-image">
          <ion-icon
            data-cy="top-purchases-card-content-no-image-icon"
            name="restaurant"
            class="no-image"
            role="img"
            aria-label="No Image"
          ></ion-icon>
        </div>
      </ng-template>
      <div class="top-purchases-card-content-product">
        <p class="top-purchases-card-content-product-category">
          {{ purchase.category }}
        </p>
        <app-tooltip [text]="isTruncated && !isMobile ? purchase.name : ''">
          <p
            #productName
            class="top-purchases-card-content-product-name"
            (mouseover)="checkTruncation()"
          >
            {{ purchase.name }}
          </p>
        </app-tooltip>
        <p class="top-purchases-card-content-product-details">
          <span class="top-purchases-card-content-product-details-id">
            #{{ purchase.productID }}
          </span>
          <span class="top-purchases-card-content-product-details-separator">
            |
          </span>
          <span class="top-purchases-card-content-product-details-weight">
            {{ product.summary.salesPackSize || purchase.weight }}
          </span>
        </p>
      </div>
    </ng-container>
  </div>
  <div class="top-purchases-card-footer">
    <p class="top-purchases-card-footer-amount">
      {{
        sortBy === 'Dollars'
          ? (purchase.amount | currency: 'USD' : true : '1.2-2')
          : purchase.cases % 1 === 0
            ? (purchase.cases | number: '1.0-0')
            : (purchase.cases | number: '1.2-2')
      }}
    </p>
  </div>
</div>
